import Vue from "vue";
import Vuex from "vuex";
import employees from "../../models/workflow/employees";
import service from "../../services/workflow/employeesW";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    new: [],
    employees: [],
    edit: [],
    deleteItem: [],
    checkTo: true,
    operDefault:null,
    employeesOperId:[]
  },

  mutations: {
    setEmployees(state, data) {
      state.employees = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },

    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setShowAdd(state, data) {
      state.showAdd = data;
    },
    setIsEdit(state, data) {
      state.isEdit = data;
    },
    setCheckTo(state, data) {
      state.checkTo = data;
    },
    setOperDefault(state,data){
      state.operDefault = data
    },
    setEmployeesOperId(state,data){
      state.employeesOperId= data
    }
  },
  actions: {
    async getEmployees(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getEmployees();

          state.commit("setEmployees", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(() => {
            let item = state.state.edit;
            let options = state.state.employeesOperId
            options = options.map((option)=>{
              if(option.empId !== item.employees ){
                return option
              }
              item = employees.fromJson({
                    operId: item.operid,
                    empId: item.employees,
                    fecDesde: item.from,
                    fecHasta: item.haNoEx ? null : item.to,
                    nomOper: item.nameOper,
                    empleado: item.nameEmp,
                   
              })
              return item
              })
           
          
            state.commit("setEmployees", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async new(state) {
      return new Promise(async (resolve, reject) => {

        try {
          await state.state.service.new(state.state.new).then(() => {
            let item = state.state.new;
            let options = state.state.employees;
            let newItem
          item.empleados.map((element,index)=>{
            newItem = employees.fromJson({
              operId:item.operId,
              empId:element,
              fecDesde:item.fecDesde,
              fecHasta:item.fecHasta,
              nomOper:item.nomOper,
              empleado:item.nombre[index],
            });
            options.push(newItem);
          })
  
         
            state.commit("setEmployees", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let options = state.state.employees;
            options = options.filter((option) => {
              return option.empId != state.state.deleteItem.empid;
            });
            state.commit("setEmployees", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
